module.exports = __webpack_public_path__ + "static/map-of-australia-3d39cebc0c5dd23ef8b8efe7a5350bb5.jpg";